import { useMemo } from "react"

import { findChildren } from "shared/lib/treeUtils"
import { ProjectChild } from "shared/types/Project"

import { useProjectData } from "entities/projects/api/useProjectData"
import { useProjectStore } from "features/project-management/model/useProjectStore"

export function useOpenProjectChildren({
  projectID
}: {
  projectID: string
}): ProjectChild[] {
  const { project } = useProjectData(projectID, true)
  const { selectedElementIDs, isDetailsViewOpen } = useProjectStore(projectID)

  return useMemo(() => {
    if (selectedElementIDs.length === 0 || !isDetailsViewOpen) {
      return [] as ProjectChild[]
    }
    return findChildren<ProjectChild>(
      selectedElementIDs,
      project?.children
    ) as ProjectChild[]
  }, [selectedElementIDs, isDetailsViewOpen, project?.children])
}
